import {RouteComponentProps} from "react-router-dom";
import Box from "@amzn/awsui-components-react/polaris/box";
import React, {useEffect, useState} from 'react';
import {parseErrorMessage} from '../../utils/errors';
import AjaxStatusIndicator from '../basic/AjaxStatusIndicator';
import {SubmissionDetails} from "../../backend/model";
import SubmissionDetailsPanel from "./SubmissionDetailsPanel";
import {getSubmission} from "../../backend/backend";
import SubmissionSearchPanel from "./SubmissionSearchPanel";
import {getApprovalUrl} from "../../backend/internalUrls";

type ApprovalPageProps = RouteComponentProps<{ submissionId?: string }>

const ApprovalPage: React.FC<ApprovalPageProps> = (props) => {
    const submissionIdFromUrl = (props.match.params.submissionId)?.trim() || ''
    const [submissionDetails, setSubmissionDetails] = useState<SubmissionDetails>()
    const [reRender, setReRender] = useState<boolean>()
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessages, setErrorMessages] = useState<string[]>([])

    useEffect(() => {
        getSubmissionDetails(submissionIdFromUrl)
    }, [submissionIdFromUrl, reRender])

    const getSubmissionDetails = async (
        submissionId: string,
    ) => {
        if (submissionId)
            await fetchSubmissionDetails(submissionId)
    }

    async function fetchSubmissionDetails(submissionId: string) {
        setIsLoading(true)

        try {
            setSubmissionDetails((await getSubmission(submissionId)).data)
        } catch(error : any ) {
            setErrorMessages([parseErrorMessage(error)])
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    function triggerReRender() {
        setReRender(!reRender)
    }

    return (
        <div id='approval-page'>
            <Box variant="h1">Approval</Box>
            <SubmissionSearchPanel
                searchHandler={(submissionId: string) => {
                    props.history.push(getApprovalUrl(submissionId))
                }}
            ></SubmissionSearchPanel>
            <br/>
            {
                submissionDetails &&
                <SubmissionDetailsPanel submissionDetails={submissionDetails} triggerReRender={triggerReRender}/>
            }
            <br/>
            <AjaxStatusIndicator errorMessage={errorMessages.join(' ')} loading={isLoading}/>
        </div>
    )
}

export default ApprovalPage
